import { AppConfigKeys } from '@rialtic/types'

export default defineNuxtRouteMiddleware((_to, _from) => {
  const featureFlags = useFeatureFlags()

  featureFlags.loadFlags()

  if (_to.path.startsWith('/dashboard/claim-search')) {
    if (!featureFlags.isEnabled(AppConfigKeys.featureClaimSearch)) {
      return navigateTo('/dashboard')
    }
  }

  if (_to.path.endsWith('/edit-modes')) {
    if (!featureFlags.isEnabled(AppConfigKeys.featurePolicyModesByClaimType)) {
      return navigateTo('/policies')
    }
  }
})
